import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiService } from '../services/api';
import styles from '../styles/shareRedirect.module.css';

const ShareRedirect: React.FC = () => {
  const { documentId } = useParams<{ documentId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAndRedirect = async () => {
      if (!documentId) {
        // No document ID → show expired page (don't reveal it's invalid)
        navigate('/expired-link');
        return;
      }

      try {
        // Call backend to get the full S3 URL
        const response = await apiService.getShareRedirect(documentId);
        
        // Redirect to the S3 URL
        window.location.href = response.share_url;
      } catch (err: any) {
        console.error('Error fetching share document:', err);
        
        // For ANY error (404, expired, invalid, etc.), show the expired page
        // This prevents leaking information about which document IDs are valid
        navigate('/expired-link');
      }
    };

    fetchAndRedirect();
  }, [documentId, navigate]);

  // Show loading state while fetching
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.spinner}></div>
        <p className={styles.loadingText}>Loading shared content...</p>
      </div>
    </div>
  );
};

export default ShareRedirect;

